import { cn } from "@/lib/utils";
import { DetailedHTMLProps, LabelHTMLAttributes } from "react";

export function Label({ children, className, ...props }: DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement> & {required?: boolean}) {
	return (
		<label 
			className={cn("block text-sm font-medium mb-1", className)}
			{...props}>
			{children}
			{props.required && <span className="text-rose-500 ml-1">*</span>}
		</label>
	);
}

export function Description({ children, className }: { children: string, className?: string }) {
	return (
		<p className={cn("text-sm text-muted-foreground", className)}>
			{children}
		</p>
	);
}